import { Button } from "@mui/material";
import { ReactNode } from "react";

import styles from "./styles";

interface Props {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
}

export default function Chip({ selected, onClick, children }: Props) {
  return (
    <Button disableRipple sx={styles.chip(selected)} onClick={onClick}>
      {children}
    </Button>
  );
}
